// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1zSfz","content":"GlobalSearch_content__1p313"};